import { Box } from 'grommet';
import React from 'react';
import { LinkItem } from './LinkItem';

const HeaderItem = ({ route, label }: { label: string; route: string }) => (
  <Box
    pad={{ horizontal: 'xsmall', vertical: 'xsmall' }}
    direction="row"
    align="center"
    focusIndicator={false}
  >
    <LinkItem route={route} label={label} />
  </Box>
);

export default HeaderItem;
